import React from 'react';
import { useQuery } from 'react-query';
import { dashboardApi } from '../../../../../api/dashboard';
import { ScaleLoader } from 'react-spinners';

const getInitials = (name = '') =>
  name
    .split(' ')
    .slice(0, 2)
    .map((n) => n[0])
    .join('')
    .toUpperCase();

const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;
  return date.toLocaleDateString('en-NG', { day: 'numeric', month: 'short', year: 'numeric' });
};

const RecentlyEnrolledLearners = () => {
  const { data: learners, isLoading } = useQuery(
    ['admin-dashboard-recently-enrolled-learners'],
    () => dashboardApi.getRecentlyEnrolledLearners(),
    {
      cacheTime: 300000,
      staleTime: 300000,
      refetchOnWindowFocus: false,
      select: (res) => res?.data,
    }
  );

  return (
    <div className="bg-white p-4 shadow rounded-lg w-full">
      <h3 className="text-sm font-medium text-gray-700 mb-4 border-b pb-2">Recently Enrolled Learners</h3>

      {isLoading ? (
        <div className="flex items-center justify-center py-10">
          <ScaleLoader color="#0A3059" height={25} />
        </div>
      ) : !learners?.length ? (
        <p className="text-center text-gray-400 text-sm py-8">No recently enrolled learners</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" className="px-4 py-3">Learner</th>
                <th scope="col" className="px-4 py-3">Department</th>
                <th scope="col" className="px-4 py-3">Date</th>
              </tr>
            </thead>
            <tbody>
              {learners.map((learner) => {
                const fullName = (learner?.name ?? `${learner?.firstName ?? ''} ${learner?.lastName ?? ''}`.trim()) || '—';
                const department = learner?.department ?? learner?.team ?? '—';
                const date = formatDate(learner?.enrolledAt ?? learner?.createdAt);

                return (
                  <tr key={learner?.id} className="bg-white border-b hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium text-gray-900 flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-xs flex-shrink-0">
                        {getInitials(fullName)}
                      </div>
                      {fullName}
                    </td>
                    <td className="px-4 py-3">{department}</td>
                    <td className="px-4 py-3 text-gray-400">{date}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RecentlyEnrolledLearners;
